"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexColumn, Table } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { ItemPreviewTooltipTraitTableHeader } from "./ItemPreviewTooltipTraitTableHeader";
import { ItemPreviewTooltipTraitTableRowSkeleton } from "./ItemPreviewTooltipTraitTableRowSkeleton";
import { MAX_TRAITS } from "./utils";
export function ItemPreviewTooltipTraitTableSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ItemPreviewTooltipTraitTableHeader />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FlexColumn className="w-full overflow-hidden"><Table header={t0} itemKey={_temp} items={range(MAX_TRAITS)} renderRow={ItemPreviewTooltipTraitTableRowSkeleton} size="xs" /></FlexColumn>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return index;
}